import React  from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import { css } from 'emotion'
import Layout from 'app/universal/layout/Layout'
import Orders from 'app/orderTool/pages/missingInformations/Orders'
import OrdersProvider from 'app/orderTool/context/OrdersProvider'
import {Helmet} from "react-helmet";
import SidebarInfo from 'app/universal/layout/sidebar/SidebarInfo'
import OrderSidebar from 'app/orderTool/components/sidebar/OrderSidebar'

const MissingInformations = (props) => {
  
  // Paramètres à passer au OrdersProvider
  const orderParams = {
    'active_missing_fields': 1,
    'limit': 300
  };

  return (
    <OrdersProvider params={orderParams}>
      <Layout reduxIsUsed={true}>
        <Helmet>
          <title>Information manquante</title>
        </Helmet>
        <SidebarInfo component={<OrderSidebar />} >
          <Container fluid={true}>
            <Row noGutters>
              <Col xs={12} sm={12}>
                <h4 className={css(styles.h4)}>Commandes avec des informations manquantes pour finaliser un devis <br/><small></small></h4>
                  <Orders router={props.history}/>
              </Col>
            </Row>
          </Container>
        </SidebarInfo>
      </Layout>
    </OrdersProvider>
  )

}


const styles = {
  h4:{
    margin: '2rem 0 1rem 0' 
  }
}

export default MissingInformations
